<script setup>
import {ref} from "vue";

defineProps(['id', 'label', 'custom'])

const model = defineModel();
let open = ref(false);
</script>

<template>
    <div class="field field--action-with-input">
        <button @click.prevent="open = !open" v-if="!open" class="whippet-button color--navy style--text">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z M12,6.41666667 C12.5522847,6.41666667 13,6.86438192 13,7.41666667 L13,11 L16.5833333,11 C17.1356181,11 17.5833333,11.4477153 17.5833333,12 C17.5833333,12.5522847 17.1356181,13 16.5833333,13 L13,13 L13,16.5833333 C13,17.1356181 12.5522847,17.5833333 12,17.5833333 C11.4477153,17.5833333 11,17.1356181 11,16.5833333 L11,13 L7.41666667,13 C6.86438192,13 6.41666667,12.5522847 6.41666667,12 C6.41666667,11.4477153 6.86438192,11 7.41666667,11 L11,11 L11,7.41666667 C11,6.86438192 11.4477153,6.41666667 12,6.41666667 Z"/></svg>
            <span>{{ custom.button_text }}</span>
        </button>
        
        <div class="input" v-if="open">
            <label :for="id" v-html="label"></label>

            <input type="text" :id="id" maxlength="100" v-model="model" />
        </div>
    </div>
</template>
